import Vue from 'vue';
import ResizeListener from 'components/widgets/ResizeListener/ResizeListener.vue';
const BfExpandingButton = Vue.extend({
    components: { ResizeListener },
    props: {
        actions: { type: Array, required: true },
        trigger: { type: String, required: true },
        title: { type: String, required: false, default: null }
    },
    data() {
        return {
            expanded: false,
            width: 500
        };
    },
    computed: {
        label() {
            if (this.expanded) {
                return this.title ?? this.trigger;
            }
            else {
                return this.trigger;
            }
        },
        actionWidth() {
            return this.width / (this.actions.length + 2);
        },
        cssVars() {
            return {
                "--action-width": `${this.actionWidth}px`,
            };
        },
        actionsList() {
            return this.expanded ? this.actions : [];
        }
    },
    mounted() {
        this.getDimensions();
    },
    methods: {
        getDimensions() {
            this.$nextTick(() => {
                if (this.$el) {
                    this.width = this.$el.getBoundingClientRect().width;
                }
            });
        },
        cancel() {
            this.toggle();
            this.$emit('cancel');
        },
        toggle() {
            this.expanded = !this.expanded;
        },
        clickItem(item) {
            this.$emit('click', item);
            this.toggle();
        }
    }
});
export default BfExpandingButton;
